import React from 'react';
import { useTranslation } from 'react-i18next';
import athenaLogo from 'src/assets/athenaLogo.svg';
import styles from './Footer.module.scss';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer data-testid="footer" className={styles.wrapper}>
      <hr className={styles.hr} aria-hidden="true" />
      <div className={styles.poweredBy} aria-label="powered by">
        powered by
      </div>
      <img className={styles.athenaLogo} src={athenaLogo} alt="Athena Health" />
      <div className={styles.a11y}>
        <a href="https://www.athenahealth.com/resources/accessibility" rel="noreferrer" target="_blank">
          {t('FOOTER_A11Y_STATEMENT')}
        </a>
      </div>
    </footer>
  );
}
